import Logo from './logo';
import Portal from './portal';
import If from './if';
import { DelayRender } from './delayRender';
import withHooksComponent from './withHooksComponent';
import UMUBg from './UMUBg/UMUBg';
import ToggleLine from './toggleLine/toggleLine';
import { Tabs, TabItem } from './tabs/tabs';
import { SimpleToggleLine } from './simpleToggleLine/simpleToggleLine';
import ProgressiveEmg from './progressiveEmg/progressiveEmg';
import { PreImg } from './preImg/preImg';
import Navigate from './navigate/navigate';
import NavigateItem from './navigate/navigateItem';
import NavigateTwoLineItem from './navigate/navigateTwoLineItem';
import MCheckbox from './MCheckbox/MCheckbox';
import Loading from './loading/loading';
import LazyRender from './lazyRender/lazyRender';
import { LazilyRender } from './lazyRender/lazilyRender';
import ImgGallery from './imgGallery/imgGallery';
import Swipe from './fullImgGallery/swipe';
import FullImgGallery, { showFullImgGallery } from './fullImgGallery/fullImgGallery';
import { A } from './frameA/frameA';
import { ErrorBoundary } from './errorBoundary';
import Emg from './emg/emg';
import { Carousel } from './carousel/carousel';
import { Breadcrumb } from './breadcrumb/breadcrumb';
import BaseErrorBoundary from './baseErrorBoundary/baseErrorBoundary';
import BaseComponent from './baseComponent/baseComponent';
import { BackTopBtn } from './backTopBtn/backTopBtn';
import { TimePicker } from './@timePicker/timePicker';
import TableSkeleton from './tableSkeleton';
import Keyword from './@Keyword';
export { AutoHeightTexarea } from './autoHeightTexarea/autoHeightTexarea';
export { IfShow } from './ifShow';
export { TransitionShow } from './transitionShow';
export { CircleProgress } from './circleProgress';

export {
    Logo,
    Portal,
    If,
    DelayRender,
    withHooksComponent,
    UMUBg,
    ToggleLine,
    Tabs,
    TabItem,
    SimpleToggleLine,
    ProgressiveEmg,
    PreImg,
    Navigate,
    NavigateItem,
    NavigateTwoLineItem,
    MCheckbox,
    Loading,
    LazyRender,
    LazilyRender,
    ImgGallery,
    Swipe,
    FullImgGallery,
    showFullImgGallery,
    A,
    ErrorBoundary,
    Emg,
    Carousel,
    Breadcrumb,
    BaseErrorBoundary,
    BaseComponent,
    BackTopBtn,
    TimePicker,
    TableSkeleton,
    Keyword,
};

export {
    SlidePicker,
    RowSlideTaskPicker,
    SlideTaskPicker,
    DATE_INFINITY,
    DATE_FORMAT,
    DATE_NOW,
    PICKER_MODE,
    renderVal,
} from './@SlidePicker';

export {
    AlertDialog,
    ConfirmDialog,
    CustomDialog,
    PortalDialog,
    PortalDialogWrapper,
    NormalDialog,
    modalServiceWrapper,
} from './modalDialog';
export { List, ListBlank, ListLoading } from './list/list';
export {
    Switch,
    Radio,
    RadioList,
    Radiobox,
    Checkbox,
    Textarea,
    NumericInput,
    MultiSelect,
    Input,
    Button,
} from './form';
export { Dialog, DialogHeader, DialogBody, DialogFooter, DialogFooterButton } from './dialog/dialog';
export { CustomTable, TextAlign, FixedDirection } from './customTable';

export enum EmgFit {
    'default',
    'contain',
    'cover',
}

export enum STYLE {
    YELLOW = 1,
    BLUE = 2,
    BLACK = 3,
}
